import { render, staticRenderFns } from "./gallery-grid.vue?vue&type=template&id=92a19fd8"
import script from "./gallery-grid.vue?vue&type=script&lang=js"
export * from "./gallery-grid.vue?vue&type=script&lang=js"
import style0 from "./gallery-grid.vue?vue&type=style&index=0&id=92a19fd8&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('92a19fd8')) {
      api.createRecord('92a19fd8', component.options)
    } else {
      api.reload('92a19fd8', component.options)
    }
    module.hot.accept("./gallery-grid.vue?vue&type=template&id=92a19fd8", function () {
      api.rerender('92a19fd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/gallery-grid.vue"
export default component.exports